import {Component, OnInit, ViewChild} from '@angular/core';
import {ThemeService} from '@lv1871/core';
import {MatDialogRef} from '@angular/material/dialog';
import {NgForm} from '@angular/forms';
import {ValidationService} from '../../../../services/validation.service';
import {translations} from '../../../../translations/de';
import {TrackingService} from '../../../../services/tracking.service';
import {TrackingAktion, TrackingCategory} from '../../../../models/enumTracking';

@Component({
    selector: 'lv-modal-dialog-portfolio-speichern',
    templateUrl: './modal-dialog-portfolio-speichern.component.html',
    styleUrls: ['./modal-dialog-portfolio-speichern.component.scss'],
    standalone: false
})
export class ModalDialogPortfolioSpeichernComponent implements OnInit {
  @ViewChild(NgForm, {static: true})
  private _ngForm;

  translations = translations;
  portfolioName: string;
  constructor(private _tracker: TrackingService,
              private _validationService: ValidationService,
              public dialogRef: MatDialogRef<ModalDialogPortfolioSpeichernComponent>
  ) {}

  ngOnInit(): void {
  }

  speichernButtonClicked(): void {
    this._validationService.markControlsDirtyAndTouched(this._ngForm.form);
    if (this._ngForm.form.controls['portfolioName'].status === 'VALID') {
      this._tracker.trackEvent(TrackingCategory.SPEICHERN, TrackingAktion.T_BUTTON, 'PortfolioSpeichern_Initial');
      this.dialogRef.close(this.portfolioName);
    }
  }

  abbrechenButtonClicked(): void {
    this.dialogRef.close();
  }

}
